/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import { CustomModal } from 'src/components'
import { useTranslation } from 'next-i18next'
import { PlusOutlined } from '@ant-design/icons'
import { Row, Col, Typography, Button } from 'antd'
import { showNotification } from 'src/core/helpers'
import styles from './StockAlertListHeader.module.scss'
import StockAlertForm from './StockAlertForm/StockAlertForm'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { createStockAlertSelector, resetStockAlertCreate } from 'src/features'
const { Title } = Typography

const StockAlertListHeader = ({ stockAlertsLength }: { stockAlertsLength: number }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [isModalVisible, setIsModalVisible] = useState(false)

  const { success: successCreation } = useAppSelector(createStockAlertSelector)
  const { width } = useWindowSize()

  useEffect(() => {
    if (successCreation) {
      setIsModalVisible(false)
      showNotification('success', t('general.OperationSuccess'))
      dispatch(resetStockAlertCreate())
    }
  }, [successCreation])

  return (
    <>
      <Row>
        <Col lg={12} xs={24} className={width <= 800 && 'has-text-centered mb-3'}>
          <Title level={5} className={styles['title']} >
            {t('general.ResultsLength', { length: stockAlertsLength })}
          </Title>
        </Col>
        <Col lg={12} xs={24} className='has-text-centered'>
          <Button
            className={width > 800 && `float-right`}
            type='primary'
            icon={<PlusOutlined />}
            onClick={() => setIsModalVisible(true)}
          >
            {t('StockAlert.AddNew')}
          </Button>
        </Col>
      </Row>

      <CustomModal
        title={t('StockAlert.FormTitle')}
        footer={null}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      >
        <StockAlertForm />
      </CustomModal>
    </>
  )
}

export default StockAlertListHeader
